import { getLastPeriodId } from "./Period.js";

export function recalculateTimeoutsForEntities(props, fixtureProfile) {
  const lastPeriod = getLastPeriodId(props.currentState.period.periodId, fixtureProfile);
  if (props.currentState.period.periodId > lastPeriod && fixtureProfile.resetTimeoutsAfterPeriods.includes(lastPeriod)) {
    const timeoutEvents = props.eventStore.filter((event) => event.eventType === "timeOut" && event.periodId > lastPeriod);
    return props.currentState.entities.map((entity) => ({
      ...entity,
      timeouts: timeoutEvents.filter((event) => event.entityId === entity.entityId).length,
    }));
  }
  return props.currentState.entities;
}
